import React from 'react';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  BarChart,
  Bar,
  CartesianGrid,
} from 'recharts';

const remittancesData = [
  { month: 'Ene', value: 1200 },
  { month: 'Feb', value: 1900 },
  { month: 'Mar', value: 1700 },
  { month: 'Abr', value: 2100 },
  { month: 'May', value: 2300 },
];

const promotionsData = [
  { name: 'Activas', value: 12 },
  { name: 'Vencidas', value: 5 },
  { name: 'Futuras', value: 8 },
];

const newCommercesData = [
  { month: 'Ene', value: 10 },
  { month: 'Feb', value: 15 },
  { month: 'Mar', value: 8 },
  { month: 'Abr', value: 20 },
  { month: 'May', value: 25 },
];

const categoriesData = [
  { name: 'Pago', value: 7 },
  { name: 'Recarga', value: 5 },
  { name: 'Promos', value: 9 },
];

const Dashboard = () => {
  const theme = useTheme();

  return (
    <Box p={3}>
      <Grid container spacing={3}>
        {/* Remesas */}
        <Grid component={Paper} elevation={1} sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>
              Remesas Recibidas (Últimos 5 meses)
            </Typography>
            <ResponsiveContainer width="100%" height={250}>
              <LineChart data={remittancesData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="month" />
                <YAxis />
                <Tooltip />
                <Line type="monotone" dataKey="value" stroke={theme.palette.primary.main} />
              </LineChart>
            </ResponsiveContainer>
        </Grid>

        {/* Promociones */}
        <Grid component={Paper} elevation={1} sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>
              Promociones por Estado
            </Typography>
            <ResponsiveContainer width="100%" height={250}>
              <BarChart data={promotionsData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Bar dataKey="value" fill={theme.palette.success.main} />
              </BarChart>
            </ResponsiveContainer>
        </Grid>

        {/* Días Feriados */}
        <Grid component={Paper} elevation={1} sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>
              Días Feriados
            </Typography>
            <Typography variant="h2" color="primary">
              14
            </Typography>
        </Grid>

        {/* Tarjetas Emitidas */}
        <Grid component={Paper} elevation={1} sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>
              Tarjetas Emitidas (Últimos 3 meses)
            </Typography>
            <Typography variant="h2" color="primary">
              327
            </Typography>
        </Grid>

        {/* Nuevos Comercios */}
        <Grid component={Paper} elevation={1} sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>
              Nuevos Comercios por Mes
            </Typography>
            <ResponsiveContainer width="100%" height={250}>
              <LineChart data={newCommercesData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="month" />
                <YAxis />
                <Tooltip />
                <Line type="monotone" dataKey="value" stroke={theme.palette.secondary.main} />
              </LineChart>
            </ResponsiveContainer>
        </Grid>

        {/* Categorías Activas */}
        <Grid component={Paper} elevation={0} sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>
              Categorías de Servicio Activas
            </Typography>
            <ResponsiveContainer width="100%" height={250}>
              <BarChart data={categoriesData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Bar dataKey="value" fill={theme.palette.warning.main} />
              </BarChart>
            </ResponsiveContainer>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Dashboard;